export { default as wrapRootElement } from './src/App';

// Handle client-side routing and page reloads
export const onClientEntry = () => {
  // Ensure proper initialization
  console.log('Gatsby client entry');
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Handle route updates for analytics or other tracking
  console.log('Route updated:', location.pathname);
};

// Handle service worker updates
export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    'This application has been updated. ' +
    'Reload to display the latest version?'
  );
  if (answer === true) {
    window.location.reload();
  }
};

// Handle routing errors
export const onRouteUpdateDelayed = () => {
  console.log('Route update delayed');
};
